import React, { useState, useEffect } from 'react'
import { Button, FormControlLabel } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'

function OpcionesAccionPesadoDestare (props) {
  const { cpe, pesadoAuto, show, rolAutorizado, printerDestare, repeso } = props
  const [textPesadoEnCabina, setTextoPesadoEnCabina] = useState('Pesado en cabina')
  const [repesar, setRepesar] = useState(false)

  useEffect(() => {
    if (repeso === 1) {
      setRepesar(true)
    } else if (repeso === 0) {
      setRepesar(false)
    }
  }, [repeso])

  const setPesadoCabina = () => {
    if (textPesadoEnCabina === 'Pesado en cabina') {
      setTextoPesadoEnCabina('Pesado en panel externo')
    } else {
      setTextoPesadoEnCabina('Pesado en cabina')
    }
    props.pesarEnCabina()
  }

  const setRepeso = () => {
    setRepesar(!repesar)
    props.updateRepeso()
  }

  return (
    <div className='contenedor-acciones-destare'>
      <div className='container-btn-destare'>
        {show && <Button
          className='btn-accion-destare'
          onClick={props.cerealAdherido}
        >
                            Reimprimir con cereal adherido
        </Button>
        }
        <Button
          className='btn-accion-destare'
          onClick={props.reimprimirTicket}
          variant='contained'
          color='primary'
          style={{ margin: '8px' }}
        >
                    Reimpresión último ticket
        </Button>
        { (pesadoAuto && !cpe) && <Button
          className='btn-accion-destare'
          onClick={setPesadoCabina}
          variant='contained'
          color='primary'
          style={{ margin: '8px' }}
        >
          {textPesadoEnCabina}</Button>
        }
        <FormControlLabel
          style={{ margin: '8px', width: '100%' }}
          control={<Button
            variant='contained'
            color='primary'
            onClick={setRepeso}
            style={{ backgroundColor: repesar ? COLORES.success : COLORES.blue.primary, width: '100%' }}
          >
                Repeso
          </Button>
          }
        />

      </div>

      { (rolAutorizado) && <div className='container-set-impresora'>
        <h6>[ Seleccionar impresora ]</h6>
        {printerDestare
          ? <Button
            className='btn-set-printer-destare'
            variant='contained'
            color='primary'
            onClick={props.onPrinterChange}
          >
            {printerDestare}
          </Button>
          : null
        }
      </div>
      }

    </div>
  )
}

export default OpcionesAccionPesadoDestare
